export const demoSectionConfig = {
  nfl: {
    title: "2026 NFL Super Bowl",
    imageUrl: "https://a.bracky.app/assets/covers/nfl/super-bowl-2026.jpg",
    volume: 500000,
    progress: 25,
    daysFromNow: 7,
    state: "live" as const,
    preSelectedOutcomes: ["philadelphia-eagles"],
  },
  scaling: {
    container: {
      mobile: "w-full",
      sm: "sm:max-w-md",
      lg: "lg:max-w-lg",
    },
    inner: {
      md: "md:scale-[1.07]",
      lg: "lg:scale-[1.07]",
      xl: "xl:scale-[1.07]",
      "2xl": "2xl:scale-[1.07]",
    },
  },
  classes: {
    section: "relative isolate z-30 w-full pt-0 pb-16 px-4",
    container: "flex justify-center w-full sm:max-w-md lg:max-w-lg mx-auto",
    innerWrapper:
      "w-full space-y-3 transform md:scale-[1.07] lg:scale-[1.07] xl:scale-[1.07] 2xl:scale-[1.07] origin-top",
  },
}
